import { createContext } from "react";
import useSocket from "../../Hooks/useSocket";

export const SocketContext = createContext();

const ContextProvider = ({ children }) => {

    const socket = useSocket();

    return <SocketContext.Provider value={socket}>
        {children}
    </SocketContext.Provider>
}

export default ContextProvider